import i18n from 'i18next'

export const languageSwitch = (lng: string): void => {
  // eslint not being useful https://github.com/i18next/i18next/issues/1035
  // eslint-disable-next-line import/no-named-as-default-member
  i18n.changeLanguage(lng)
  location.reload()
}
